document.addEventListener('DOMContentLoaded', function() {

    /*Section what can you do*/
    if($('.swiperWhatCanMain').length > 0) {
        let swiperWhatCanTumbnl = new Swiper('.swiperWhatCanTumbnl', {
            breakpoints: {
                320: {
                    slidesPerView: 4.1,
                    freeMode: true,
                },
                700: {
                    slidesPerView: 7,
                    spaceBetween: 10,
                }
            },
            centeredSlides: true,
            loop: true,
            clickable: true,
            effect: 'slide',
            slideActiveClass: 'active',
            pagination: {
                el: ".swiper-pagination.swiper-what-can-text-pagination-custom",
                dynamicBullets: true,
            },
            on: {
                slideChange: function () {
                    if ($(document).width() > 700) {
                        document.querySelectorAll('.swiperWhatCanTumbnl .swiper-slide img').forEach((img, index) => {
                            let scale = 0.6; // Default small size
                            if (index === this.activeIndex) scale = 1; // Center image largest
                            else if (index === this.activeIndex - 1 || index === this.activeIndex + 1) scale = 0.9;
                            else if (index === this.activeIndex - 2 || index === this.activeIndex + 2) scale = 0.7;

                            img.style.transform = `scale(${scale})`;
                        });
                    } else {
                        document.querySelectorAll('.swiperWhatCanTumbnl .swiper-slide img').forEach((img, index) => {
                            let scale = 0.75; // Default small size
                            if (index === this.activeIndex) scale = 1; // Center image largest
                            else if (index === this.activeIndex - 1 || index === this.activeIndex + 1) scale = 0.9;
                            else if (index === this.activeIndex - 2 || index === this.activeIndex + 2) scale = 0.8;

                            img.style.transform = `scale(${scale})`;
                        });
                    }

                }
            }
        });
        let swiperWhatCanMain = new Swiper('.swiperWhatCanMain', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            effect: 'slide',
            thumbs: {
                swiper: swiperWhatCanTumbnl,
            },
        });

        let swiperWhatCanText = new Swiper('.swiperWhatCanText', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            effect: 'slide',
            thumbs: {
                swiper: swiperWhatCanTumbnl,
            },
            navigation: {
                nextEl: ".swiperWhatCanText .swiper-button-next",
                prevEl: ".swiperWhatCanText .swiper-button-prev",
            },
        });

        function updateWhatCanAriaHidden() {
            document.querySelectorAll('.swiperWhatCanText .swiper-slide').forEach(function(slide) {
                slide.setAttribute('aria-hidden', 'true');
            });
            var activeSlide = document.querySelector('.swiperWhatCanText .swiper-slide-active');
            if (activeSlide) activeSlide.setAttribute('aria-hidden', 'false');
        }
        updateWhatCanAriaHidden();

        swiperWhatCanMain.on('slideChangeTransitionEnd', function () {
            const activeIndex = $('.swiperWhatCanMain .swiper-slide-active').data('swiper-slide-index');
            swiperWhatCanText.slideToLoop(activeIndex);
        });

        swiperWhatCanText.on('slideChange', function () {
            setTimeout(function () {
                const activeMainSlider = $('.swiperWhatCanText .swiper-slide-active').data('swiper-slide-index');
                swiperWhatCanTumbnl.slideToLoop(activeMainSlider);
                swiperWhatCanMain.slideToLoop(activeMainSlider);
                updateWhatCanAriaHidden();
            }, 100);
        });

        swiperWhatCanTumbnl.on('sliderMove', function (sliderMoved) {
            setTimeout(function () {
                const activeMainSlider = $('.swiperWhatCanTumbnl .active').data('swiper-slide-index');
                swiperWhatCanMain.slideToLoop(activeMainSlider);
                swiperWhatCanText.slideToLoop(activeMainSlider);
            }, 100);
        });
    }

    /*Customer reviews section*/
    if($('.pdp-reviews-section').length > 0) {
        setTimeout(function () {
            let currentValue = $('.pdp-reviews-section .jdgm-rev-widg__summary-average').text();
            currentValue = currentValue.replace("out of 5", "");
            currentValue = currentValue.trim();
            $('.pdp-reviews-section .jdgm-rev-widg__summary-average').text(currentValue);
        }, 1000);
    }

    /*FAQ section*/
    if($('.faq-question').length > 0) {
        // Hide whitespace/nbsp-only block elements and <br> tags so NVDA doesn't announce them as "blank"
        document.querySelectorAll('.faq-answer p, .faq-answer div, .faq-answer li').forEach(function(el) {
            if (el.textContent.replace(/\u00a0/g, '').trim() === '') {
                el.setAttribute('aria-hidden', 'true');
            }
        });
        // Hide the second of each consecutive <br> pair to prevent NVDA announcing "blank",
        // while keeping the first <br> as a natural reading pause
        document.querySelectorAll('.faq-answer br').forEach(function(br) {
            var prev = br.previousSibling;
            while (prev && prev.nodeType === 3 && prev.textContent.trim() === '') {
                prev = prev.previousSibling;
            }
            if (prev && prev.nodeName === 'BR') {
                br.setAttribute('aria-hidden', 'true');
            }
        });
        document.querySelectorAll(".faq-question").forEach(function (question) {
            question.addEventListener("click", function () {
                var block = this.closest(".faq-block");
                var isExpanded = block.classList.toggle("faq-active-tab");
                this.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
                var answerId = this.getAttribute('aria-controls');
                if (answerId) {
                    var answer = document.getElementById(answerId);
                    if (answer) {
                        answer.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
                        // Move focus into the answer so NVDA reads it from here,
                        // preventing the virtual buffer from jumping elsewhere on the page.
                        if (isExpanded) {
                            answer.setAttribute('tabindex', '-1');
                            answer.focus({ preventScroll: true });
                        }
                    }
                }
            });
        });
    }
});

// Patch all Judge.me preview badges (star rating widgets) to be read as a graphic
// instead of "clickable button X stars, X stars"
(function () {
    function patchStarBadges() {
        document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
            if (badge.getAttribute('data-a11y-patched')) return;

            // Prefer the data attribute; fall back to reading the text element
            var rating = badge.getAttribute('data-average-rating');
            if (!rating) {
                var textEl = badge.querySelector('.jdgm-prev-badge__text');
                if (textEl) rating = parseFloat(textEl.textContent).toFixed(2);
            }

            badge.setAttribute('role', 'img');
            badge.setAttribute('aria-label', (rating ? rating : '') + ' out of 5 star rating');
            badge.querySelectorAll('*').forEach(function (child) {
                child.setAttribute('aria-hidden', 'true');
            });
            badge.setAttribute('data-a11y-patched', 'true');

            // If the outer wrapper div has onclick it is announced as "clickable" —
            // role="presentation" removes its AT role while keeping mouse click intact
            var parent = badge.parentElement;
            if (parent && parent.hasAttribute('onclick') && !parent.getAttribute('data-a11y-patched')) {
                parent.setAttribute('role', 'presentation');
                parent.setAttribute('data-a11y-patched', 'true');
            }
        });
    }

    var starObserver = new MutationObserver(function () {
        if (document.querySelector('.jdgm-prev-badge')) {
            patchStarBadges();
        }
    });

    starObserver.observe(document.body, { childList: true, subtree: true });

    // Also run once in case badges have already rendered
    patchStarBadges();
})();

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};


function addToCartV1(variant_id, btn_id, redirect_to_cart = 0) {

    $(`#${btn_id}`).text('...');

    const data = {
        "id": variant_id,
        "quantity": 1
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            setTimeout(function(){
                // if(redirect_to_cart == 1){
                    document.location.href="/cart";
                // } else {
                //     document.location.reload();
                // }
            },700);
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function addToCartFromPDP(variant_id, btn_id, loadingText = 'Please wait...') {
    $(`#${btn_id}`).val(loadingText);

    let data = {};
    if(variant_id == 0){
         data = {
            "id":  $('.active-size-variant').data('variant-id'),
            "quantity": 1
        }
    } else {
        data = {
            "id": variant_id,
            "quantity": 1
        }
    }


    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            //$(`#${btn_id}`).val('Thank you!');
            setTimeout(function () {
                if (typeof upSaleEnable != "undefined" && upSaleEnable == true) {
                    const cleanURL = window.location.origin + window.location.pathname;
                    document.location.href = `${cleanURL}#upsale=1`;
                    document.location.reload();
                } else {
                    document.location.href = '/cart';
                }
            }, 700);
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function openContactSalePopup() {
    $('.notify-overflow').show();
    $('.notify-popup').show();
}
function closeContactSalePopup() {
    $('.notify-overflow').hide();
    $('.notify-popup').hide();
}

// Patch "Huupe" pronunciation site-wide: screen readers say "hoop" instead of "Hugh P."
(function () {
    var skipTags = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1 };

    function fixHuupeInText(textNode) {
        var text = textNode.nodeValue;
        var rx = /Huupe|huupe|HUUPE/g;
        if (!rx.test(text)) return;
        rx.lastIndex = 0;
        var fragment = document.createDocumentFragment();
        var lastIndex = 0;
        var match;
        while ((match = rx.exec(text)) !== null) {
            if (match.index > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            // Hide visual text from screen readers
            var visual = document.createElement('span');
            visual.setAttribute('aria-hidden', 'true');
            visual.textContent = match[0];
            fragment.appendChild(visual);
            // Inline sr-only styles so NVDA reads "hoop" — no reliance on any CSS class
            var sr = document.createElement('span');
            sr.setAttribute('style', 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0');
            sr.textContent = 'hoop';
            fragment.appendChild(sr);
            lastIndex = rx.lastIndex;
        }
        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }
        textNode.parentNode.replaceChild(fragment, textNode);
    }

    function fixHuupeAttrs(el) {
        ['aria-label', 'alt', 'title'].forEach(function (attr) {
            var val = el.getAttribute(attr);
            if (val && /huupe/i.test(val)) {
                el.setAttribute(attr, val.replace(/Huupe/g, 'hoop').replace(/HUUPE/g, 'hoop').replace(/huupe/g, 'hoop'));
            }
        });
    }

    function walkNode(node) {
        if (node.nodeType === 3) {
            fixHuupeInText(node);
        } else if (node.nodeType === 1) {
            if (skipTags[node.tagName]) return;
            if (node.getAttribute('aria-hidden') === 'true') return;
            fixHuupeAttrs(node);
            Array.from(node.childNodes).forEach(walkNode);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        walkNode(document.body);
    });
})();